/*
 * @format
 */

import * as types from '../action-types';
import Logger from '../../components/Logger';

export const getPartnerAccessRequests =
  (diagnosticsJsonApi, callback) => async dispatch => {
    try {
      const response = await diagnosticsJsonApi.findAll(
        'partner-generated-access-request',
      );

      const data = response?.data;

      if (data) {
        dispatch({
          type: types.PARTNER_ACCESS_REQUESTS_RECEIVED,
          partnerAccessRequests: data,
        });

        if (callback) {
          callback();
        }
      }
    } catch (err) {
      Logger.error('Error fetching partner access requests:', err);

      if (callback) {
        callback(err);
      }
    }
  };

export const removePartnerAccessRequest = requestId => ({
  type: types.PARTNER_ACCESS_REQUESTS_REMOVE,
  requestId,
});
